import {
  Phone,
  Mail,
  MapPin,
  ArrowRight
} from 'lucide-react';
import './App.css';
import { ImageWithFallback } from './components/elements/ImageWithFallback.tsx';
import { Button } from './components/elements/Button.tsx';
import { Card, CardContent } from './components/elements/Card.tsx';
import DATA_MOCKUP from './data/data-mockup.tsx';

export default function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex flex-row items-center space-x-3">
              <div
                className="w-20 h-20 rounded-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: "url('/FB_IMG_1766319608533.jpg')",
                }}
              />
              <div></div>
            </div>

            <nav className="hidden md:flex space-x-8">
              {/* <a
                href="#home"
                className="text-gray-700 hover:text-rose-600 transition-colors font-medium"
              > */}
              <button type="button" className="link-like">
                หน้าหลัก
              </button>
              {/* </a> */}
              {/* <a
                href="#"
                className="text-gray-700 hover:text-rose-600 transition-colors font-medium"
              > */}
              <button type="button" className="link-like">
                การรักษา
              </button>
              {/* </a> */}
              {/* <a
                href="#"
                className="text-gray-700 hover:text-rose-600 transition-colors font-medium"
              > */}
              <button type="button" className="link-like">
                เกี่ยวกับเรา
              </button>
              {/* </a> */}
              {/* <a
                href="#"
                className="text-gray-700 hover:text-rose-600 transition-colors font-medium"
              > */}
              <button type="button" className="link-like">
                บทความ
              </button>
              {/* </a> */}
              {/* <a
                href="#contact"
                className="text-gray-700 hover:text-rose-600 transition-colors font-medium"
              > */}
              <button type="button" className="link-like">
                ติดต่อเรา
              </button>
              {/* </a> */}
            </nav>

            <Button className="bg-rose-600 hover:bg-rose-700 text-white px-6 shadow-sm">
              สอบถามเพิ่มเติม
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section
        id="home"
        className="relative min-h-[90vh] flex items-center overflow-hidden"
      >
        <div
          className="absolute bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/S__12779526.jpg')",
            width: '100%',
            height: '100%',
            backgroundSize: 'cover',
          }}
        ></div>
      </section>

      {/* Appreciated Customers Section */}
      <section
        id="data"
        className="py-24 bg-gradient-to-br from-rose-50 to-pink-50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl text-gray-900 mb-6">ขอขอบคุณ</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {DATA_MOCKUP.map((post) => (
              <Card
                key={post.id ?? post.image ?? post.title}
                className="overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 group bg-white"
              >
                <div className="relative">
                  <div className="aspect-[16/10] overflow-hidden">
                    <ImageWithFallback
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl text-gray-900 -mt-3 transition-colors">
                    {post.title}
                  </h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Button
            variant="outline"
            className="border-rose-200 text-rose-700 hover:bg-rose-50"
          >
            ดูเพิ่มเติม
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl mb-6">คลินิกเวชกรรมเฌอบัว</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              ช่องทางการติดต่อ
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            <Card className="bg-gray-800 border-gray-700 text-white">
              <CardContent className="p-8 text-center">
                <Phone className="w-12 h-12 text-rose-400 mx-auto mb-4" />
                <h3 className="text-xl mb-3">ติดต่อทางโทรศัพท์</h3>
                <p className="text-gray-300 mb-4">พูดคุยกับทีมรักษาของเรา</p>
                <p className="text-rose-400 font-medium text-lg">
                  098 098 9949
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gray-800 border-gray-700 text-white">
              <CardContent className="p-8 text-center">
                <Mail className="w-12 h-12 text-rose-400 mx-auto mb-4" />
                <h3 className="text-lg mb-3">
                  ติดต่อผ่านเพจเฟซบุ๊กและอินสตาแกรม
                </h3>
                <p className="text-gray-300 mb-4">ขอคำแนะนำ</p>
                <p className="text-rose-400 font-medium text-lg">
                  CherBour Clinic
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gray-800 border-gray-700 text-white">
              <CardContent className="p-8 text-center">
                <MapPin className="w-12 h-12 text-rose-400 mx-auto mb-4" />
                <h3 className="text-xl mb-3">ติดต่อได้ตามตำแหน่งที่ตั้ง</h3>
                <p className="text-gray-300 mb-4">เฌอบัว คลินิกเวชกรรม</p>
                <p className="text-rose-400 font-medium text-base">
                  614/3 ถ. พุทธมณฑลสาย 2 แขวงบางไผ่ บางแค กรุงเทพมหานคร 10160
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <Button
              size="lg"
              className="bg-rose-600 hover:bg-rose-700 text-white px-12 py-4 text-lg"
            >
              จองการปรึกษา
            </Button>
            <p className="text-gray-400 mt-4">
              ไม่มีข้อผูกมัด • สามารถนัดหมายในวันเดียวกันได้
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center">
                  <div
                    className="w-20 h-10 rounded-full bg-cover bg-center bg-no-repeat"
                    style={{
                      backgroundImage: "url('/FB_IMG_1766319608533.jpg')",
                    }}
                  />
                </div>
                <div>
                  <span className="text-xl font-medium">
                    เฌอบัว คลินิกเวชกรรม
                  </span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg mb-6">Services</h4>
              <ul className="space-y-3 text-gray-400">
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    โปรแกรมรักษาสิว
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    โปรแกรมรักษาฝ้า
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    โปรแกรมโบทูลินุ่มท็อกซิน
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    อื่นๆ
                  </button>
                  {/* </a> */}
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg mb-6">Clinic</h4>
              <ul className="space-y-3 text-gray-400">
                <li>
                  {/* <a
                    href="#about"
                    className="hover:text-rose-400 transition-colors"
                  > */}
                  <button type="button" className="link-like">
                    ติดต่อเรา
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    ทีมรักษาของเรา
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
                  <button type="button" className="link-like">
                    Before & After
                  </button>
                  {/* </a> */}
                </li>
                <li>
                  {/* <a
                    href="#contact"
                    className="hover:text-rose-400 transition-colors"
                  > */}
                  <button type="button" className="link-like">
                    การติดต่อ
                  </button>
                  {/* </a> */}
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg mb-6">เวลาเปิดให้บริการ</h4>
              <div className="space-y-3 text-gray-400">
                <div className="flex justify-between">
                  <span>วันจันทร์</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
                <div className="flex justify-between">
                  <span>วันอังคาร</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
                <div className="flex justify-between">
                  <span>วันพุธ</span>
                  <span>ไม่เปิดให้บริการ</span>
                </div>
                <div className="flex justify-between">
                  <span>วันพฤหัสบดี</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
                <div className="flex justify-between">
                  <span>วันศุกร์</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
                <div className="flex justify-between">
                  <span>วันเสาร์</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
                <div className="flex justify-between">
                  <span>วันอาทิตย์</span>
                  <span>12:00 - 19:00 น.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400">
              &copy; 2025 CherBour Clinic. All rights reserved. CQC Registered.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0 text-gray-400">
              {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
              <button type="button" className="link-like">
                นโยบายความเป็นส่วนตัว
              </button>
              {/* </a> */}
              {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
              <button type="button" className="link-like">
                ข้อกำหนดการให้บริการ
              </button>
              {/* </a> */}
              {/* <a href="#" className="hover:text-rose-400 transition-colors"> */}
              <button type="button" className="link-like">
                คุกกี้
              </button>
              {/* </a> */}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
